import { render, staticRenderFns } from "./FormResponseType5.vue?vue&type=template&id=5b02a5a6&scoped=true&"
import script from "./FormResponseType5.vue?vue&type=script&lang=js&"
export * from "./FormResponseType5.vue?vue&type=script&lang=js&"
import style0 from "./FormResponseType5.vue?vue&type=style&index=0&id=5b02a5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b02a5a6",
  null
  
)

export default component.exports